import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/LeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { useNavigate, useParams, Link } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from '../../components/ui/toast';
import notfound from '../../notFound.png';
import {
    ArrowLeft, Package, MapPin, Box, CreditCard, Barcode, Printer, FileText, Trash2, CheckCircle2, User
} from "lucide-react";

function ShipmentDetails() {
    let navigate = useNavigate();
    const { slip_no } = useParams();
    const [shipmentdetails, setShipmentdetails] = useState([]);
    const [status, setStatus] = useState([]);
    const { headers1, headers2, logout } = AuthUser();
    useEffect(() => {
        GetPickupDetails();
    }, []);

    const GetPickupDetails = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Customershipmentdetailsbyslipno',
            headers: headers1,
            data: {
                slip_no: slip_no
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var shipmentdata = response.data.value;
                    var statusdata = response.data.value.shipmentallstatus;
                    setShipmentdetails(shipmentdata);
                    setStatus(statusdata);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
            });
    }

    const ShipmentDelete = (id) => {
        if (window.confirm('Do You  want to delete ?')) {
            axios({
                method: 'post',
                url: Global.baseUrl + 'CustomerShipmentDelete',
                headers: headers1,
                data: {
                    slip_no: id
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        toast.success(response.data.message);
                        navigate('/Shipmentlist/All');
                    }
                    else {
                        toast.warn(response.data.message);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
        } else {
        }
    }

    const infoBlock = (title, fields) => (
        <div className="px-details-block">
            <h6 className="px-details-block__title">{title}</h6>
            <div className="px-kv px-kv--stack">
                {fields.map(([k, v], i) => (
                    <div className="px-kv__item" key={i}>
                        <div className="px-kv__label">{k}</div>
                        <div className="px-kv__value">{v || '-'}</div>
                    </div>
                ))}
            </div>
        </div>
    );

    const fromFields = [
        ['Sender Name', shipmentdetails.sender_name],
        ['Sender Address', `${shipmentdetails.sender_address}, ${shipmentdetails.sendercity}, ${shipmentdetails.sendercountry} ${shipmentdetails.sender_zip}`],
        ['Sender City', shipmentdetails.sendercity],
        ['Sender State', shipmentdetails.senderstate],
        ['Sender Country', shipmentdetails.sendercountry],
        ['Sender Email', shipmentdetails.sender_email],
        ['Sender Mobile', shipmentdetails.sender_phone],
    ];

    const toFields = [
        ['Receiver Name', shipmentdetails.reciever_name],
        ['Receiver Address', `${shipmentdetails.reciever_address}, ${shipmentdetails.receivercity}, ${shipmentdetails.receivercountry} ${shipmentdetails.reciever_zip}`],
        ['Receiver City', shipmentdetails.receivercity],
        ['Receiver State', shipmentdetails.receiverstate],
        ['Receiver Country', shipmentdetails.receivercountry],
        ['Receiver Email', shipmentdetails.reciever_email],
        ['Receiver Mobile', shipmentdetails.reciever_phone],
    ];

    const billFields = shipmentdetails.bill_to == 'S' ? fromFields : toFields;

    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <div className="px-pagehead">
                        <div className="px-pagehead__left">
                            <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                                <ArrowLeft size={16} />
                            </button>
                            <h2 className="px-pagehead__title">AWB #{slip_no}</h2>
                            <span className="px-detail-status" dangerouslySetInnerHTML={{ __html: shipmentdetails.shipmentstatus }}></span>
                        </div>
                        <div className="px-pagehead__actions">
                            <Link to={`/ShipmentLabel?slipno=${slip_no}`} target="_blank" className="px-icon-btn" title="Print Label"><Barcode size={15} /></Link>
                            <Link to={`/ShipmentPrintReceipt/${slip_no}`} target="_blank" className="px-icon-btn" title="Print Receipt"><Printer size={15} /></Link>
                            <Link to={`/ShipmentInvoice/${slip_no}`} target="_blank" className="px-icon-btn" title="Print Invoice"><FileText size={15} /></Link>
                            <button className="px-icon-btn px-icon-btn--danger" title="Delete" onClick={() => ShipmentDelete(slip_no)}><Trash2 size={15} /></button>
                            {shipmentdetails.shipment_type == 'International' &&
                                <button className="px-icon-btn" title="Forward through"><Box size={15} /></button>
                            }
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <div className="px-card px-mb">
                                <div className="px-card__head">
                                    <span className="px-card__title"><Package size={17} />Shipment Information</span>
                                    <small className="px-muted-sm">Created By: {shipmentdetails.name}</small>
                                </div>
                                <div className="px-card__body">
                                    <div className="px-kv">
                                        {[
                                            ['Created Date', shipmentdetails.entrydate],
                                            ['Shipment No.', shipmentdetails.slip_no],
                                            ['Order No.', '-'],
                                            ['Order Type', shipmentdetails.nrd],
                                            ['Shipment Type', shipmentdetails.shipment_type],
                                            ['Services', shipmentdetails.services_name],
                                            ['Bill To', shipmentdetails.bill_to == 'S' ? 'Sender' : shipmentdetails.bill_to == 'R' ? 'Receiver' : 'Other'],
                                            ['Type', shipmentdetails.booking_mode == 'Prepaid'
                                                ? shipmentdetails.booking_mode
                                                : `${shipmentdetails.booking_mode} $${shipmentdetails.total_cod_amt}`],
                                            ['Insured', shipmentdetails.insurence_charge != '0.00' ? 'Yes' : 'NO'],
                                        ].map(([k, v], i) => (
                                            <div className="px-kv__item" key={i}>
                                                <div className="px-kv__label">{k}</div>
                                                <div className="px-kv__value">{v || '-'}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="px-card px-mb">
                                <div className="px-card__head">
                                    <span className="px-card__title"><MapPin size={17} />Shipment Details</span>
                                </div>
                                <div className="px-card__body">
                                    <div className="px-details-3col">
                                        {infoBlock('Ship From', fromFields)}
                                        {infoBlock('Ship To', toFields)}
                                        {infoBlock('Bill To', billFields)}
                                    </div>
                                </div>
                            </div>

                            <div className="px-card px-mb">
                                <div className="px-card__head">
                                    <span className="px-card__title"><Box size={17} />Package Details</span>
                                </div>
                                <div className="px-card__body">
                                    <div className="px-kv">
                                        {[
                                            ['Applicable Weight (in Kg)', `${shipmentdetails.volumetric_weight}KG`],
                                            ['Dead Weight (in Kg)', `${shipmentdetails.weight}KG`],
                                            ['Volumetric Weight (in kg)', `${shipmentdetails.volumetric_weight}KG`],
                                            ['Shipment value', `$${shipmentdetails.total_amt}`],
                                            ['Number of Boxes', '-'],
                                        ].map(([k, v], i) => (
                                            <div className="px-kv__item" key={i}>
                                                <div className="px-kv__label">{k}</div>
                                                <div className="px-kv__value">{v || '-'}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="px-card px-mb">
                                <div className="px-card__head">
                                    <span className="px-card__title"><Box size={17} />Box Details</span>
                                </div>
                                <div className="px-card__body">
                                    <div className="px-table-wrap">
                                        <table className="px-table">
                                            <thead>
                                                <tr>
                                                    <th>Product Name</th>
                                                    <th>Dimensions (cm)</th>
                                                    <th>Weight (KG)</th>
                                                    <th>Price</th>
                                                    <th>QTY</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="5" className="text-end"><strong>Total</strong></td>
                                                    <td>-</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="px-card">
                                <div className="px-card__head">
                                    <span className="px-card__title"><CreditCard size={17} />Payment Details</span>
                                </div>
                                <div className="px-card__body">
                                    <div className="px-kv">
                                        {[
                                            ['Transaction ID', '-'],
                                            ['Payment Mode', shipmentdetails.customer_booking_mode],
                                            ['Total Paid Amount', `$${shipmentdetails.total_amt}`],
                                            ['Bill To (Customer)', shipmentdetails.bill_to == 'S'
                                                ? shipmentdetails.sender_company_name
                                                : shipmentdetails.receiver_company_name],
                                            ['Customer Account No.', shipmentdetails.Customer_Account_No],
                                        ].map(([k, v], i) => (
                                            <div className="px-kv__item" key={i}>
                                                <div className="px-kv__label">{k}</div>
                                                <div className="px-kv__value">{v || '-'}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-4">
                            <div className="px-card px-mb">
                                <div className="px-card__head"><span className="px-card__title">Shipment Info</span></div>
                                <div className="px-card__body">
                                    <div className="px-kv px-kv--stack">
                                        {[
                                            ['Origin', `${shipmentdetails.sendercity}, ${shipmentdetails.senderstate}, ${shipmentdetails.sendercountry} - ${shipmentdetails.sender_zip}`],
                                            ['Destination', `${shipmentdetails.receivercity}, ${shipmentdetails.receiverstate}, ${shipmentdetails.receivercountry} - ${shipmentdetails.reciever_zip}`],
                                            ['Last Location', shipmentdetails.shipmentlastlocation],
                                            ['Expected Schedule Delivery', `${shipmentdetails.expected_date} by EOD`],
                                        ].map(([k, v], i) => (
                                            <div className="px-kv__item" key={i}>
                                                <div className="px-kv__label">{k}</div>
                                                <div className="px-kv__value">{v || '-'}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="px-card px-mb">
                                <div className="px-card__head"><span className="px-card__title"><CheckCircle2 size={16} />Shipment POD</span></div>
                                <div className="px-card__body">
                                    <div className="px-pod-grid">
                                        <div>
                                            <div className="px-kv__label">Receiver's Signature</div>
                                            {shipmentdetails.signature_img != undefined && shipmentdetails.signature_img != "" ?
                                                <img src={`${Global.logoUrl}${shipmentdetails.signature_img}`} className="img-fluid px-pod-img" alt="Receiver signature" />
                                                :
                                                <img src={notfound} className="img-fluid px-pod-img" alt="No signature" />
                                            }
                                        </div>
                                        <div>
                                            <div className="px-kv__label">Receiver's Image</div>
                                            {shipmentdetails.receiver_image != undefined && shipmentdetails.receiver_image != "" ?
                                                <img src={`${Global.logoUrl}${shipmentdetails.receiver_image}`} className="img-fluid px-pod-img" alt="Receiver image" />
                                                :
                                                <img src={notfound} className="img-fluid px-pod-img" alt="No image" />
                                            }
                                        </div>
                                    </div>
                                    <div className="px-kv px-kv--stack" style={{ marginTop: 12 }}>
                                        <div className="px-kv__item">
                                            <div className="px-kv__label">Receiver Name</div>
                                            <div className="px-kv__value">{shipmentdetails.delevered_to || '-'}</div>
                                        </div>
                                        <div className="px-kv__item">
                                            <div className="px-kv__label">Receiver Mobile</div>
                                            <div className="px-kv__value">{shipmentdetails.delevered_no || '-'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="px-card px-sticky">
                                <div className="px-card__head"><span className="px-card__title"><MapPin size={16} />Shipment Tracking</span></div>
                                <div className="px-card__body">
                                    <ul className="px-timeline">
                                        {status.map((st, i) => (
                                            <li className="px-timeline__item" key={i}>
                                                <span className="px-timeline__dot"><User size={12} /></span>
                                                <div className="px-timeline__body">
                                                    <div className="px-timeline__time">{st.pickup_time}</div>
                                                    <div className="px-timeline__title">{st.Details}</div>
                                                    <div className="px-timeline__city">{st.city}</div>
                                                    {st.Activites && <div className="px-timeline__act">{st.Activites}</div>}
                                                    <small className="px-muted-sm">Updated By: {st.name}</small>
                                                </div>
                                            </li>
                                        ))}
                                        {status.length === 0 && <li className="px-muted-sm">No tracking events yet.</li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </main>
        </>
    );
}
export default ShipmentDetails;
